import './App.css';
import React from 'react';

import HHistogram from './graphs/h_histogram/h_histogram.component';
import VHistogram from './graphs/v_histogram/v_histogram.component';
import ProgressBar from './graphs/progressbar/progressbar.component';
import Sparkline from './graphs/sparkline/sparkline.component';
import MultiSparkline from './graphs/multi_sparkline/multi.sparkline.component';
import Table from './graphs/table/table.component';

class App extends React.Component {

 render() {
  
  return (
      <div>
     
      <HHistogram/>
       <VHistogram/>
      <ProgressBar/>
      <Sparkline /> 
      <MultiSparkline />
      <Table />
    </div>
  );
    }
}
export default App;
